// W149 · 2026-05-28 · identificação institucional do operador (LGPD Art. 5º X).
// Configurável via env vars. Default placeholder até produto definir entidade legal.

export interface CompanyLegalInfo {
  razaoSocial: string;
  cnpj: string;
  endereco: string;
  emailLegal: string;
  emailDpo: string;
  dpoNome: string;
}

export const COMPANY_INFO: CompanyLegalInfo = {
  razaoSocial: (import.meta.env.VITE_COMPANY_RAZAO_SOCIAL as string | undefined) || 'Nullscience Tecnologia Ltda. (placeholder)',
  cnpj: (import.meta.env.VITE_COMPANY_CNPJ as string | undefined) || '00.000.000/0001-00 (placeholder)',
  endereco: (import.meta.env.VITE_COMPANY_ENDERECO as string | undefined) || 'Endereço a definir',
  emailLegal: (import.meta.env.VITE_COMPANY_EMAIL_LEGAL as string | undefined) || 'legal@builder.app',
  emailDpo: (import.meta.env.VITE_COMPANY_EMAIL_DPO as string | undefined) || 'dpo@builder.app',
  dpoNome: (import.meta.env.VITE_COMPANY_DPO_NOME as string | undefined) || 'DPO a designar',
};
